import React from 'react';

import { widgetDefaultProps, widgetPropType } from '@glowforge/gf-styled/models';
import { getContentByType } from '@glowforge/gf-styled/models/page';

import UniqueCreations from './unique-creations';

const UniqueCreationsWidget = ({
  sections,
  model,
}) => {
  const { textStrings } = model;
  const title = textStrings?.title;
  const expandButtonText = textStrings?.['expand-button-text'];
  const buttonLink = getContentByType(sections, 'buttonLink')[0];

  const backgroundSection = getContentByType(sections, 'backgroundImage')[0];
  const backgroundImage = backgroundSection?.fields?.desktopImage?.fields?.file?.url;
  const colorFields = backgroundSection?.fields?.desktopColor?.fields ?? null;
  const backgroundColor = colorFields && `${colorFields.hue}.${colorFields.tint}`;
  const backgroundSize = backgroundSection?.fields?.desktopSize ?? null;
  const backgroundRepeat = backgroundSection?.fields?.desktopRepeat ?? null;

  const imagesArray = getContentByType(sections, 'imagesArray')[0];
  const images = imagesArray?.fields?.images;

  return (
    <UniqueCreations
      title={title}
      expandButtonText={expandButtonText}
      buttonLink={buttonLink}
      images={images}
      backgroundImage={backgroundImage}
      backgroundColor={backgroundColor}
      backgroundSize={backgroundSize}
      backgroundRepeat={backgroundRepeat} />
  );
};

UniqueCreationsWidget.propTypes = widgetPropType;

UniqueCreationsWidget.defaultProps = widgetDefaultProps;

export default UniqueCreationsWidget;
